module.exports = __webpack_public_path__ + "static/media/comm_en.ffb23b3a.txt";